import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../traffic/InstrumentedButton';

require('./style.scss');

const EditCancelButton = ({ edit_email, handleClick, edit_text, cancel_text, aria_edit_text, aria_cancel_text }) => {
  return (
    <Button
      design='inline'
      text={edit_email ? cancel_text : edit_text}
      className='edit-cancel-btn'
      onClick={handleClick}
      trafficName='edit-recovery-email.button'
      aria-label={edit_email ? aria_cancel_text : aria_edit_text}
    />
  );
};

EditCancelButton.propTypes = {
  cancel_text: PropTypes.string.isRequired,
  edit_text: PropTypes.string.isRequired,
  aria_edit_text: PropTypes.string.isRequired,
  aria_cancel_text: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  edit_email: PropTypes.bool.isRequired,
};

export default EditCancelButton;
